const ArrowDown = (
    <svg
        fill="currentColor"
        height="6"
        viewBox="0 0 13 6"
        width="13"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.79289 5.29289L0.5 0H12.5L7.20711 5.29289C6.81658 5.68342 6.18342 5.68342 5.79289 5.29289Z"
            fill="currentColor"
        />
    </svg>
);

const ArrowUp = (
    <svg
        fill="currentColor"
        height="6"
        viewBox="0 0 12 6"
        width="12"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.70711 0.707106L12 6L0 6L5.29289 0.707106C5.68342 0.316582 6.31658 0.316582 6.70711 0.707106Z"
            fill="currentColor"
        />
    </svg>
);

const ArrowRight = (
    <svg
        fill="currentColor"
        height="12"
        viewBox="0 0 6 12"
        width="6"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.29289 6.70711L0 12L-5.24537e-07 0L5.29289 5.29289C5.68342 5.68342 5.68342 6.31658 5.29289 6.70711Z"
            fill="currentColor"
        />
    </svg>
);

const ArrowLeft = (
    <svg
        fill="currentColor"
        height="12"
        viewBox="0 0 6 12"
        width="6"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0.707106 5.29289L6 0L6 12L0.707106 6.70711C0.316582 6.31658 0.316582 5.68342 0.707106 5.29289Z"
            fill="currentColor"
        />
    </svg>
);

export default {
    bottom: ArrowUp,
    'bottom-left': '',
    'bottom-right': '',
    left: ArrowRight,
    right: ArrowLeft,
    top: ArrowDown,
    'top-left': '',
    'top-right': '',
};
